export default __webpack_public_path__ + "static/media/basketIcon.44e379c3.svg";